var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGoogleSpecifics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.67378 6.59091V9.64773H13.394C12.7782 11.5 11.1001 12.8267 8.67378 12.8267C5.7856 12.8267 3.44242 10.6648 3.44242 8C3.44242 5.33523 5.78252 3.1733 8.67378 3.1733C9.97316 3.1733 11.1586 3.61364 12.0731 4.33807L14.5117 2.08523C12.9722 0.789773 10.9215 0 8.67378 0C3.88273 0 0 3.58239 0 8C0 12.4176 3.88273 16 8.67378 16C15.9527 16 17.56 9.71875 16.8457 6.60227L8.67378 6.59091Z",
    fill: "#122442"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogleSpecifics);
export default __webpack_public_path__ + "static/media/icon-google-specifics.9492574e.svg";
export { ForwardRef as ReactComponent };